import type { HTMLAttributes } from 'react';

import { LoadingRegion } from '@/components/ui/loading-region';
import { SPINNER_APPEARANCE, SPINNER_SIZE } from './types/spinner-variants-enums';
import { Spinner } from '@/components/ui/spinner';
import { cn } from '@/lib/utils';

interface MainContentLoadingProps extends HTMLAttributes<HTMLDivElement> {
  label?: string;
}

export function MainContentLoading({
  className,
  label = 'Loading page…',
  ...props
}: MainContentLoadingProps) {
  return (
    <LoadingRegion
      className={cn(
        'flex min-h-[calc(100vh-180px)] items-center justify-center px-6 py-10',
        className
      )}
      label={label}
      {...props}
    >
      <div className="flex flex-col items-center gap-3 text-center text-content-secondary">
        <Spinner appearance={SPINNER_APPEARANCE.BRAND} size={SPINNER_SIZE.LG} />
        <p className="text-sm">{label}</p>
      </div>
    </LoadingRegion>
  );
}
